import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import EventEmitter from '../../../utils/events'
// import { isEqual } from 'lodash'

import ReactHoverObserver from 'react-hover-observer'

// Components
// import Price from '../../../pages/PriceCalculation/Price'

// Actions
import { GetExtends, getOrderClean } from '../../../actions/orders'

// Utils
import { formatCurrency } from '../../../utils/currency'
import { renderFullDate } from '../../../utils/time'
// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// Styles
import './index.scss'
import Extent from '../Extent'

// Elements
import PanelHeader from '../../elements/panelHeader'
import LabelWrapper from '../../elements/labelWrapper'
import Divider from '../../elements/divider'
import Grid from '../../elements/grid'

class HoverExtent extends Component {

  constructor (props) {
    super(props)
    this.onHoverChanged = this.onHoverChanged.bind(this)
    this.checkPos = this.checkPos.bind(this)
    this.state = {
      active: false,
      status: 'loading',
      item: undefined,
      // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1',
      adjustPopupBottom: false
    }
  }

  componentDidMount () {
    EventEmitter.addListener('price updated', this.checkPos)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('price updated', this.checkPos)
  }

  checkPos () {
    if (this.state.active) {
      this.app = ReactDOM.findDOMNode(document.getElementById('app'))
      let orderListElement = document.getElementsByClassName('orderlist__list')
      if (orderListElement.length > 0) {
        this.listElement = ReactDOM.findDOMNode(orderListElement[0])
      }
      if (this.listElement !== undefined) {
        this.listContent = this.listElement.childNodes[0]
      }
      if (this.listElement !== undefined && this.listContent !== undefined) {
        if (this.state.active === true) {
          let hoverRect = ReactDOM.findDOMNode(this).getElementsByClassName('hover_extent-popup')[0].getBoundingClientRect()
          // let listScroll = this.app.scrollTop
          // let listHeight = this.listContent.offsetHeight
          // let itemListPos = (hoverRect.bottom + listScroll + 151)
          let windowHeight = window.innerHeight
          let bottomOffset = windowHeight - (hoverRect.top + hoverRect.height)
          // if (itemListPos > listHeight && hoverRect.top > 0 || bottomOffset < 31) {
          if (bottomOffset < 31) {
            // let itemHeight = hoverRect.height
              // console.log('--- HOVER POPUP BELOW LIST EDGE! (' + itemListPos + ' > ' + listHeight + ')', itemListPos - listHeight)
            if (this.state.adjustPopupBottom !== true) {
              this.setState({ adjustPopupBottom: true })
            }
          }
        } else {
          if (this.state.adjustPopupBottom !== false) {
            this.setState({ adjustPopupBottom: false })
          }
        }
      }
    } else {
      if (this.state.adjustPopupBottom !== false) {
        this.setState({ adjustPopupBottom: false })
      }
    }
  }
  componentDidUpdate (prevProps, prevState) {
    this.checkPos()
  }
  // componentWillReceiveProps (nextPost) {
  //   this.listElement = undefined
  //   this.listContent = undefined
  //   this.checkPos()
  // }
  getOrder (id) {
    this.props.getOrderClean(id).then((res) => {
      this.setState({
        item: res.data,
        status: 'loaded'
        // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
      }, () => {
        this.checkPos()
      })
    }, () => {
      this.setState({
        status: 'failed'
      })
    })
  }

  onHoverChanged (data) {
    if (data.isHovering !== this.state.active) {
      this.setState({
        active: data.isHovering,
        status: (data.isHovering) ? this.state.status : 'loading',
        item: (data.isHovering) ? this.state.item : undefined
      }, () => {
        if (data.isHovering) {
          this.getOrder(this.props.id)
        } else {
          if (this.state.adjustPopupBottom !== false) {
            this.setState({ adjustPopupBottom: false })
          }
        }
      })
    }
  }

  renderOther () {
    if (this.state.item.OrderType === 4) {
      return (
        <div className='extent_other'>
          <PanelHeader text={translation('889')} />
          <Divider />
          <Grid cols={[1, 'min-content']}>
            <div>{translation('1206')}</div>
            {this.state.item.OtherTitle || ''}
          </Grid>
          <Grid cols={[1, 'min-content']}>
            <div>{translation('1021')}</div>
            {this.state.item.OtherDescription || ''}
          </Grid>
          <Grid cols={[1, 'min-content']}>
            <div>{translation('641')}</div>
            {this.state.item.Price || 0}
          </Grid>
          <Grid cols={[1, 'min-content']}>
            <div>{translation('13339')}</div>
            {this.state.item.Environment || 0}
          </Grid>
        </div>
      )
    }
    return undefined
  }
  renderPrices () {
    let hasAwaiting = this.state.item.HasAwaiting
    let hasAwaitingAddon = this.state.item.HasAwaitingAddon
    if (this.state.item.OrderType !== 4) {
      let basePaint = <Extent
        order={this.props.id}
        department={0}
        // showAgreementPrice={this.state.showAgreementPrice}
        extents={[{
          type: 'base',
          editable: false,
          showEditLink: false,
          noTitle: true,
          overrideInnerTitle: translation('2093') + ' ' + translation('161'),
          viewMode: 'hover',
          showOnlyWork: true,
          useSelectedEvaluation: true
        }]}
        />

      let addonPaint = <Extent
        order={this.props.id}
        department={0}
        // showAgreementPrice={this.state.showAgreementPrice}
        extents={[{
          type: 'addon',
          editable: false,
          showEditLink: false,
          noTitle: true,
          overrideInnerTitle: translation('161') + ' ' + translation('1045'),
          viewMode: 'hover',
          showOnlyWork: true
        }]}
        />

      let baseBody = <Extent
        order={this.props.id}
        department={1}
        // showAgreementPrice={this.state.showAgreementPrice}
        extents={[{
          type: 'base',
          editable: false,
          showEditLink: false,
          noTitle: true,
          overrideInnerTitle: translation('2093') + ' ' + translation('14779'),
          viewMode: 'hover',
          showOnlyWork: true
        }]}
        />

      let addonBody = <Extent
        order={this.props.id}
        department={1}
        // showAgreementPrice={this.state.showAgreementPrice}
        extents={[{
          type: 'addon',
          editable: false,
          showEditLink: false,
          noTitle: true,
          overrideInnerTitle: translation('14779') + ' ' + translation('1045'),
          viewMode: 'hover',
          showOnlyWork: true
        }]}
        />

      return (
        <div>
          {this.props.auth.departmentType !== 1 && (<span className={'showPriceItem'}>
            {(hasAwaiting) && (
              <div className='color_diff'>{translation('2729')}</div>
            )}
            {this.state.item.HasExtent && basePaint}
            {hasAwaitingAddon && (
              <div className='color_diff'>{translation('17840')}</div>
            )}
            {this.state.item.HasExtentAddon && addonPaint}
          </span>)}
          {(this.props.auth.departmentType !== 0 && !(this.props.auth.departmentType === 2 && this.state.item.ExternalCompanyId !== null)) && (<span className={'showPriceItem'}>
            {!hasAccess([6], this.props.auth.user.UserType) /* && this.state.item.HasExtentBodyShop */ && baseBody}
            {!hasAccess([6], this.props.auth.user.UserType) && this.state.item.HasExtentBodyShopAddon && addonBody}
          </span>)}

          {(!this.state.item.HasExtent && !this.state.item.HasExtentBodyShop) && this.props.auth.departmentType !== 1 && this.state.item.OrderType !== 1 && (
            <div>
              <div className='extent_other custom'>
                <Grid cols={[1, 'min-content']}>
                  <div>{translation('641')}</div>
                  <span>{formatCurrency(this.state.item.Price || 0)}</span>
                </Grid>
                <Grid cols={[1, 'min-content']}>
                  <div>{translation('13339')}</div>
                  <span>{formatCurrency(this.state.item.Environment || 0)}</span>
                </Grid>
              </div>
            </div>
          )}
        </div>
      )
    }
    return undefined
  }
  renderPopup () {
    let positionAdjustStyle = null
    if (this.state.adjustPopupBottom === true) {
      positionAdjustStyle = { bottom: 30, top: 'auto' }
    }
    if (this.state.status === 'loading') {
      return (
        <div className='hover_extent-popup' style={positionAdjustStyle}>
          <p className='loading'>
            <span className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </span>
          </p>
        </div>
      )
    }
    if (this.state.status === 'failed') {
      return (
        <div className='hover_extent-popup' style={positionAdjustStyle}>
          <p className='loading'>
            {translation('2269')}
          </p>
        </div>
      )
    }
    // const onChange = (e) => {
    //   if (e !== undefined) {
    //     if (e.target.name === 'showAgreementPrice') {
    //       let show = window.localStorage.getItem('showAgreementPrice') === '1'
    //       window.localStorage.setItem('showAgreementPrice', show ? 0 : 1)
    //       this.setState({
    //         showAgreementPrice: !show
    //       })
    //     }
    //   }
    //   return window.localStorage.getItem('showAgreementPrice') === '1'
    // }
    // let checked = this.state.showAgreementPrice
    // // console.log(this.state.item)
    // const renderCheck = () => {
    //   if (!hasAccess([6], this.props.auth.user.UserType)) return undefined
    //   return (
    //     <div className='checkbox__custom__wrapper'>
    //       <div className='checkbox__custom'>
    //         <input type='checkbox' name='showAgreementPrice' id='sshowAgreementPrice' checked={checked} onChange={onChange} />
    //         <label htmlFor='sshowAgreementPrice'>{translation('12318')}
    //         </label>
    //       </div>
    //     </div>
    //   )
    // }
    return (
      <div className='hover_extent-popup' style={positionAdjustStyle}>
        <div className='extent_box clearfix'>
          <div className='white__box'>
            {/* {renderCheck()} */}
            {this.renderPrices()}
            {this.renderOther()}
            {this.renderColors()}
            {hasSubscriptionPermission(this.props.auth, 10) && this.renderComments()}
          </div>
        </div>
      </div>
    )
  }

  renderColors () {
    let { item } = this.state
    if (
      (item.Color === null || item.Color === '') &&
      (item.ColorCode === null || item.ColorCode === '') &&
      (item.ColorVariant === null || item.ColorVariant === '') &&
      (item.ColorAmount === null || item.ColorAmount === '')
    ) return null

    return (
      <div className='colorDiv'>
        <PanelHeader text={translation('179')} />
        <Divider />
        <Grid cols={[1, 'min-content']}>
          <div>{translation('179')}</div>
          {item.Color || ''}
        </Grid>
        <Grid cols={[1, 'min-content']}>
          <div>{translation('79')}</div>
          {item.ColorCode || ''}
        </Grid>
        {this.props.auth.departmentType !== 1 && (<Grid cols={[1, 'min-content']}>
          <div>{translation('13388')}</div>
          {item.ColorVariant || ''}
        </Grid>)}
        {this.props.auth.departmentType !== 1 && (<Grid cols={[1, 'min-content']}>
          <div>{translation('13392')}</div>
          {item.ColorAmount || ''}
        </Grid>)}
      </div>
    )
  }

  renderComments () {
    if (this.state.item.Notes.length === 0) return null
    const renderNote = (note, key) => {
      // console.log('Note', note)
      let labelText = (
        <span>
          <span>{note.NoteUserName}</span>: {renderFullDate(note.NoteDate)}
        </span>
      )
      return (
        <div key={key} className='note'>
          <LabelWrapper labelText={labelText}>
            {translation(note.SourceDictionaryKey)}: {note.Note}
          </LabelWrapper>
        </div>
      )
    }
    return (
      <div className='notes'>
        <PanelHeader text={translation('93')} />
        <Divider />
        {this.state.item.Notes.map(renderNote)}
      </div>
    )
  }

  render () {
    return (
      <ReactHoverObserver
        className='hover_extent'
        hoverDelayInMs={1000}
        hoverOffDelayInMs={500}
        onHoverChanged={this.onHoverChanged}
        shouldDecorateChildren={false}>
        <span>
          {this.props.children}
          {this.state.active && this.renderPopup()}
        </span>
      </ReactHoverObserver>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  GetExtends,
  getOrderClean
})(HoverExtent)



// WEBPACK FOOTER //
// ./src/app/shared/components/HoverExtent/index.js